import fetch from 'utils/fetch';


export function cdrToday(keyword,pagesize,currentPage) {
    const data = {
        keyword,
        pagesize,
        currentPage
    };
    return fetch({
        url: '/cdrTodayQuery',
        method: 'get',
        params : data
    });
}




// WEBPACK FOOTER //
// ./src/api/cdrToday.js